module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.e68987a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/views/affiliatecard/font/AmwayIcons.eot?5v2gxx
// module id = KC4n
// module chunks = 0